import React from "react";
import axios from "axios";
import { utilLoopHelper } from "../utils";
import { pageFilter, getArtistCookie, hasAnoAccess } from "../data/page_data";
import { parse } from "query-string";
import { Button } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Loading from "../components/loading";
import CssLoader from "../components/CssLoader";
import NewsList from "../components/NewsList";
import { navigate } from "@reach/router";

import ShareButton from "../components/ShareButton";
import * as ReactGA from "react-ga";
import FloatingButton from "../components/FloatingButton";

class NewsPageDetail extends React.Component {
  constructor(props) {
    super(props);
    this.params = parse(this.props.location.search);
    this.pageData = pageFilter(this.props.artist, "../");
    this.state = {
      share: false,
    };
    this.cookie = getArtistCookie();
  }

  toggleShare = () => {
    this.setState({ share: !this.state.share });
  };

  componentDidMount() {
    var pass = this.params.bypass == "cms";
    if (!pass && !this.cookie) {
      if (!hasAnoAccess(this.props.artist)) {
        navigate("join");
        return;
      }
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
    axios
      .get(
        "/w/api/" +
          this.pageData.artist.id +
          "/news-detail?code=" +
          this.params.code,
        {
          headers: {
            PortalAuth: this.cookie,
          },
        }
      )
      .then((response) => {
        var respData = response.data;
        this.setState((state) => ({ data: respData }));
      })
      .catch((error) => {
        document.location.href = "join";
      });
  }

  render() {
    return (
      <>
        <CssLoader css={this.pageData.artist.css} />
        {this.pageData.artist.floating_url && (
          <FloatingButton url={this.pageData.artist.floating_url} />
        )}
        <Navbar
          back="../news"
          title="NEWS"
          data={this.pageData}
          gohome={this.params.home}
        />
        {!this.state.data ? (
          <Loading />
        ) : (
          <>
            <div className="content news">
              <div className="news-detail" style={{ padding: 0 }}>
                {this.state.data.video_url ? (
                  <div className="video video-watch">
                    <div>
                      <video
                        src={this.state.data.video_url}
                        autoPlay
                        poster={this.state.data.image}
                        controls
                      ></video>
                    </div>
                  </div>
                ) : (
                  <div className="container" style={{ marginTop: "2em" }}>
                    <div className="news-detail-img">
                      <img src={this.state.data.image} />
                    </div>
                  </div>
                )}
              </div>
              <div className="container">
                <div className="news-detail-text">
                  <div className="text-title">{this.state.data.title}</div>
                  {this.state.data.description
                    .split("\n")
                    .map((item, index) => {
                      return <p>{item}</p>;
                    })}
                </div>
                <Button
                  onClick={() => this.setState({ share: true })}
                  color="none"
                  className="more btn-share"
                >
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                      <g transform="translate(-237.041 -1076)">
                        <g
                          className="a"
                          transform="translate(247.707 1085.636)"
                        >
                          <path
                            d="M-492.652,97.374h0a2.048,2.048,0,0,0-1.769.24l-9.147,6.137-4.452,2.987h0l-6.755,4.533a2.418,2.418,0,0,0-1.06,2.212,2.417,2.417,0,0,0,1.216,1.9l4.183,1.852v-.023a1.188,1.188,0,0,0,1.027-.306l10.475-9.958a.278.278,0,0,1,.287-.057.284.284,0,0,1,.193.27.27.27,0,0,1-.076.188l-9.362,10.184a.6.6,0,0,0-.156.406v5.134a1.777,1.777,0,0,0,.892,1.574,1.731,1.731,0,0,0,1.317.153,1.731,1.731,0,0,0,1.039-.823l1.87-3.369,5.053,2.25a2.407,2.407,0,0,0,2.136-.089,2.407,2.407,0,0,0,1.222-1.754l3.239-21.39a1.931,1.931,0,0,0,.023-.308A2.039,2.039,0,0,0-492.652,97.374Zm-13.2,26.015a.535.535,0,0,1-.311.249.523.523,0,0,1-.42-.048.6.6,0,0,1-.268-.524v-4.21l2.819,1.256Zm13.384-23.958h0l-3.239,21.4a1.209,1.209,0,0,1-.62.885,1.192,1.192,0,0,1-1.062.043l-9.055-4.034,8.795-9.565a1.484,1.484,0,0,0-.049-2.062,1.484,1.484,0,0,0-2.062-.022l-10.474,9.96-3.692-1.648a1.219,1.219,0,0,1-.713-1.008,1.219,1.219,0,0,1,.533-1.113l20.354-13.656a.836.836,0,0,1,.859-.038.835.835,0,0,1,.438.74A.67.67,0,0,1-492.467,99.431Z"
                            transform="translate(515.844 -97.272)"
                            stroke-width="0.5"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span>Share</span>
                </Button>
              </div>
              {this.state.data.other && (
                <div className="berita-populer">
                  <div className="container">
                    <h4>Berita Lain</h4>
                    <ul>
                      {utilLoopHelper(
                        this.state.data.other.items,
                        (item, index) => {
                          return <NewsList data={item} />;
                        }
                      )}
                    </ul>
                  </div>
                </div>
              )}
              <ShareButton
                view={this.state.share}
                shareUrl={
                  `http://funseleb.com/w/${encodeURIComponent(
                    this.pageData.artist.path
                  )}/news-detail?code=` + this.params.code
                }
                title={this.state.data.title}
                toggle={this.toggleShare}
              />
            </div>
          </>
        )}
        <Footer />
      </>
    );
  }
}

export default NewsPageDetail;
